import React from 'react' 
// import './App.css';

// import skylerfigmaheadshot from './../src/assets/skyler-figma-headshot.png';
// import bitlyportfolioshot from '../src/assets/bitly-portfolio-shot.png';
// import unicornstackportfolioshot from '../src/assets/unicornstack-portfolio-shot.png';
// import laurencircleheadshot from '../src/assets/lauren-circle-headshot.png';
// import megancircleheadshot from '../src/assets/megan-circle-headshot.png';

const Home = () => {
    return (

        <div>
        {/* <div className="container">
            <h4 className="center">Home</h4>
            <p>Hi</p>
        </div> */}

{/* <div class="navbar">
<span class="navbar-toggle" id="js-navbar-toggle">
    <i class="fas fa-bars"></i>
</span>
<a href="#" class="logo"><b>Skyler Basco</b></a>
<ul class="main-nav" id="js-menu">
    <li>
      <a href="#" class="nav-links">Home</a>
       
    </li>
    <li>
        <a href="#" class="nav-links">About</a>
    </li>
    <li>
        <a href="#" class="nav-links">Videos</a>
    </li>
    <li>
        <a href="#" class="nav-links">Projects</a>
    </li>
    <li>
        <a href="#" class="nav-links">Resources</a>
    </li>
</ul>

</div> */}


<br/>
<br/>
<br/>
<br/>
<br/>

<br/>
<div class="columnsintro-home">
        <div class="columnintro-home">
    <img className = "landingportfolioshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/skyler-figma-headshot.png"></img>
      
              </div>
        <div class="columnintro-home">
        
        <h1 className="introh1">
    <b>
    Hey, I'm Skyler! ✌️
    </b>
    </h1>
    
    <p>
    <p className="filmingjourneyline"> Filming my journey through tech while coding and designing cool things 🦄 </p>
    ↳ Content Creator @ <a target="_blank" href="https://www.youtube.com/c/SkylerBasco" className="revuelinks">YouTube</a> 
    <br/>
    ↳ Former SWE Intern @ <a target="_blank" href="https://bit.ly" className="revuelinks">Bitly</a> 
    <br/>
    </p>
    
        </div>
        </div>
<br/>
        <br/>
        <br/>

<div className="newestvideoslanding">
  <h1><b>⬇️ In a nutshell, I...</b></h1>
</div>


<br/>
<br/>



<div className="recent-video-videos">
<h1><b>...create YouTube videos, 🎬</b></h1>

                <iframe className="bitlyvideopreview"  src="https://www.youtube.com/embed/Vfck2ivMA5E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                <br/>
                <br/>
                <a
                className="general-button"
                href="https://www.youtube.com/c/SkylerBasco"
                target="_blank"
                rel="noopener noreferrer"
            >
                See more on my channel!
            </a>
            </div>

<h1 className="recentprojectslandingtitles">
  <br/>
  <b>
  ...code and design products, 💻
  </b>
  
  </h1>
  <br/>
<div class="columnsproject-home">
        <div class="columnproject-home">
    <img className = "landingportfolioshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2063%20(1).png"></img>
        
        <h2>
    <b>
    Bitly API Explorer
    </b>
    </h2>
            <br/>
            <p>
    Easier space for users to interact with HTTP Request Methods from Bitly's API 
    </p>
    <br/>
    <p>
      <a className="peoplelinks" href="https://github.com/bitly/sprinterns2022">Learn more!</a>
    </p>
              </div>
        <div class="columnproject-home">
        <img className = "landingportfolioshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/Group%2064%20(1).png"></img>
        
        <h2>
    <b>
    Unicorn Stack
    </b>
    </h2>           
        <br/>
        <p>
        Gamified platform to strengthen financial habits through AR, 3D models, budgeting.  
    </p>
    <br/>
    <p>
      <a className="peoplelinks" href="https://github.com/bitly/sprinterns2022">Learn more!</a>
    </p>
        </div>
        </div>
        <div>
<h4 className="recentprojectslandingtitles">
  <a
    className="general-button"
    href="https://devpost.com/software/unicorn-stack"
    target="_blank"
    rel="noopener noreferrer"
  >
  Explore all of my projects
  
  </a>
  </h4>
  </div>
        





<br/>
<div className="peoplelandingsection">
<br/>
  <h1 className="recentprojectslandingtitles">
  <br/>
  <br/>
  <b>
   
  ...collab with cool people, 👥
  <br/>
  </b>
  <br/>
  </h1>
  <br/>

  <div className="peoplecolumns">
  {/* <img className = "landingheadshot" src={laurencircleheadshot} />    */}
  <img className = "landingheadshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/lauren-circle-headshot.png"></img>
   <br/>
    <p>
    “Skyler possesses all of the attributes needed to <u className="peoplelinks">carry the future of tech</u> – 
    <br/>
    <br/>
    a passion so contagious that it inspires everyone around her towards excellence, a drive to take initiative and push the bounds of what is expected, and a <u className="peoplelinks">creative mind centered around empathy</u>.”
    <br/>
    <br/>
    - <a href="https://www.linkedin.com/in/lauren-avilla-071467229/" className="peoplelinks">Lauren Avilla</a>, Former Software Engineering Intern at Bitly 
    </p>
    <br/>
  </div>
  
  
  <div className="peoplecolumns">
  {/* <img className = "landingheadshot" src={megancircleheadshot} /> */}
  <img className = "landingheadshot" src="https://cdn.glitch.global/53a3415d-1f94-42fa-9c52-8076d07f9d8c/megan-circle-headshot.png"></img>
    <br/>
    <p>
    “...I consistently began to see her <u className="peoplelinks">tremendous character & teamwork skills</u> in action. Skyler is creative and hardworking. 
    <br/>
    <br/>
    It is evident that she is a remarkable talent and a <u className="peoplelinks">promising entrepreneur</u>, and will be successful with her future endeavors.”
    <br/>
    <br/>
    - <a className="peoplelinks" href="https://www.linkedin.com/in/megan-stratton/">Megan Stratton</a>, Student at Lehigh University 
    </p>
    <br/>
  </div>  
  <br/>  
</div>

<br/>
<br/>

<div className="newsletterlanding">
  <h1><b>...and build community! 🌎</b></h1>
  <br/>
  <p>
  Let's stay in touch! Sign up for "Skyler's Tech Squad," a free newsletter where I share tech resources, memes, and personal updates. <br/> <br/> By subscribing, you agree with Revue’s <a target="_blank" href="https://www.getrevue.co/terms" className="revuelinks">Terms of Service</a> and <a target="_blank" href="https://www.getrevue.co/privacy" className="revuelinks">Privacy Policy</a>.
  </p>

  <div id="revue-embed">
    <form action="https://www.getrevue.co/profile/skylerbasco/add_subscriber" method="post" id="revue-form" name="revue-form"  target="_blank">
    <div class="revue-form-group">
      <input class="revue-form-field" placeholder="Email Address" type="email" name="member[email]" id="member_email"></input>
    </div>
    
    <div class="revue-form-actions">
      <input type="submit" value="Subscribe" name="member[subscribe]" id="member_submit" className="subscribe-button"></input>
    </div>
    <br/>
    </form>
  </div>
</div>

{/* <div className="newestvideoslanding">
<p class="socialsfooter"> */}
{/* Thanks for scrolling by! Want to connect? */}

{/* </p> */}

  {/* <SocialIcon url="https://www.linkedin.com/in/skylerbasco/" className="socialmediaicon"/>
&nbsp;
  <SocialIcon url="https://www.youtube.com/c/SkylerBasco" className="socialmediaicon"/>
&nbsp;
  <SocialIcon url="https://www.instagram.com/theskylerbasco/" className="socialmediaicon"/>
&nbsp;
  <SocialIcon url="https://twitter.com/jaketrent" className="socialmediaicon"/>
&nbsp;
  <SocialIcon url="mailto:theskylerbasco@gmail.com?subject = Feedback&body = Message" className="socialmediaicon"/> */}
{/* </div> */}
</div>
    )
}

export default Home
